import React from "react";
import App from "../../app/App";
import LoginContainer from "./LoginContainer";

export default () => (
  <App>
    <LoginContainer />
  </App>
);
